var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget widget-chart-one"},[_vm._m(0),_c('div',{staticClass:"widget-content"},[_c('div',{attrs:{"id":"orderStatus"}},[_c('apexchart',{attrs:{"type":"bar","options":_vm.options,"series":_vm.generateSeriesForYear}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-heading"},[_c('h5',{},[_vm._v("Status des Factures")])])
}]

export { render, staticRenderFns }